import { gql, useQuery } from '@apollo/client'
import { BrandStoriesQuery, BrandStoriesQueryVariables, Scalars } from 'types/graphql'
import { adminStoryFragment } from 'modules/admin/stories/queries/story'

const storiesQuery = gql`
  ${adminStoryFragment}
  query BrandStories($brandId: ID!, $includeDrafts: Boolean!) {
    brand(id: $brandId) {
      id
      stories(includeDrafts: $includeDrafts) {
        id
        ...AdminStoryFields
      }
    }
  }
`
interface Options {
  includeDrafts?: boolean
}
export const useBrandStories = (brandId: Scalars['ID'], options: Options = { includeDrafts: false }) => {
  return useQuery<BrandStoriesQuery, BrandStoriesQueryVariables>(storiesQuery, {
    variables: {
      brandId,
      includeDrafts: options.includeDrafts
    }
  })
}
